import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

function changeSorting(sorting, direction) {
    const category = GA_EVENTS.catalogSorting.category;
    const action = GA_EVENTS.catalogSorting.actions.changeSorting;
    const label = sorting + ' - ' + direction;

    setBehaviourEvent({ category, action, label, beforeUnload: true });
}

export {
    changeSorting
};